import { render, staticRenderFns } from "./DocumentChange.vue?vue&type=template&id=22ad3599&scoped=true&"
import script from "./DocumentChange.vue?vue&type=script&lang=js&"
export * from "./DocumentChange.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChange.vue?vue&type=style&index=0&id=22ad3599&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad3599",
  null
  
)

export default component.exports